import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import ListSubheader from "@mui/material/ListSubheader";
import Switch from "@mui/material/Switch";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import Icon from "@mdi/react";
import {
	mdiWeb,
	mdiInstagram,
	mdiWeatherNight,
	mdiWhiteBalanceSunny,
	mdiVote,
} from "@mdi/js";
import { useAppStore } from "../store/appStore";
import { useWindowSize } from "../hooks/windowHooks";
import Top12DataExportButton from "./Top12/Top12DataExportButton";
import Top14DataExportButton from "./Top14/Top14DataExportButton";
import Top16DataExportButton from "./Top16/Top16DataExportButton";
import Top18DataExportButton from "./Top18/Top18DataExportButton";
import Top21DataExportButton from "./Top21/Top21DataExportButton";
import Top30DataExportButton from "./Top30/Top30DataExportButton";
import Top51LastRefreshTime from "./Top51/Top51LastRefreshTime";
import Top30VoteLastRefreshTime from "./Top30/Top30VoteLastRefreshTime";
import Top30TrendsLastRefreshTime from "./Top30/Top30TrendsLastRefreshTime";
import Top30VoteTrendOptions from "./Top30/Top30VoteTrendOptions";
import Top21VoteLastRefreshTime from "./Top21/Top21VoteLastRefreshTime";
import Top21TrendsLastRefreshTime from "./Top21/Top21TrendsLastRefreshTime";
import Top21VoteCompareLastRefreshTime from "./Top21/Top21VoteCompareLastRefreshTime";
import Top21TrendOptions from "./Top21/Top21TrendOptions";
import Top18VoteLastRefreshTime from "./Top18/Top18VoteLastRefreshTime";
import Top18TrendsLastRefreshTime from "./Top18/Top18TrendsLastRefreshTime";
import Top18VoteCompareLastRefreshTime from "./Top18/Top18VoteCompareLastRefreshTime";
import Top18TrendOptions from "./Top18/Top18TrendOptions";
import Top16VoteLastRefreshTime from "./Top16/Top16VoteLastRefreshTime";
import Top16TrendsLastRefreshTime from "./Top16/Top16TrendsLastRefreshTime";
import Top16VoteCompareLastRefreshTime from "./Top16/Top16VoteCompareLastRefreshTime";
import Top16TrendOptions from "./Top16/Top16TrendOptions";
import Top14VoteLastRefreshTime from "./Top14/Top14VoteLastRefreshTime";
import Top14TrendsLastRefreshTime from "./Top14/Top14TrendsLastRefreshTime";
import Top14VoteCompareLastRefreshTime from "./Top14/Top14VoteCompareLastRefreshTime";
import Top14TrendOptions from "./Top14/Top14TrendOptions";
import Top14VoteOptions from "./Top14/Top14VoteOptions";
import Top12VoteLastRefreshTime from "./Top12/Top12VoteLastRefreshTime";
import Top12TrendsLastRefreshTime from "./Top12/Top12TrendsLastRefreshTime";
import Top12VoteCompareLastRefreshTime from "./Top12/Top12VoteCompareLastRefreshTime";
import Top12RankTrendOptions from "./Top12/Top12RankTrendOptions";
import Top12VoteTrendOptions from "./Top12/Top12VoteTrendOptions";
import OverallRankTrendOptions from "./Overall/OverallRankTrendOptions";
import OverallRankTrendLastRefreshTime from "./Overall/OverallRankTrendLastRefreshTime";

export const sidebarWidth = 275;

const Menu = () => {
	const { width } = useWindowSize();
	const listOption = useAppStore((state) => state.listOption);
	const sortEnabled = useAppStore((state) => state.sortEnabled);
	const setSortEnabled = useAppStore((state) => state.setSortEnabled);
	const setListOption = useAppStore((state) => state.setListOption);
	const darkModeEnabled = useAppStore((state) => state.darkModeEnabled);
	const setDarkModeEnabled = useAppStore((state) => state.setDarkModeEnabled);
	const page = useAppStore((state) => state.page);
	const setPage = useAppStore((state) => state.setPage);

	const handleChange = (event) => {
		if (event.target.name === "sortEnabled") {
			setSortEnabled(event.target.checked);
		} else if (event.target.name === "listOption") {
			setListOption(event.target.checked ? "m" : "f");
		} else if (event.target.name === "page") {
			setPage(event.target.value);
		}
	};

	return (
		<>
			<Box pt={2} pb={5}>
				<Stack alignItems="center">
					<img
						alt="The Next Era 2022"
						src={`${process.env.PUBLIC_URL}/images/next-era-logo-bg-01.png`}
						width={sidebarWidth * 0.65}
						loading="lazy"
					/>
				</Stack>
			</Box>
			<Divider />
			{page === "top51-votes" || page === "top51-trend" ? (
				<Top51LastRefreshTime />
			) : page === "top30-vote-trend" || page === "top30-rank-trend" ? (
				<Top30TrendsLastRefreshTime />
			) : page === "top30-votes" ? (
				<Top30VoteLastRefreshTime />
			) : page === "overall-rank-trend" ? (
				<OverallRankTrendLastRefreshTime />
			) : page === "top21-vote-trend" || page === "top21-rank-trend" ? (
				<Top21TrendsLastRefreshTime />
			) : page === "top21-votes" ? (
				<Top21VoteLastRefreshTime />
			) : page === "top21-vote-compare" ? (
				<Top21VoteCompareLastRefreshTime />
			) : page === "top18-vote-trend" || page === "top18-rank-trend" ? (
				<Top18TrendsLastRefreshTime />
			) : page === "top18-vote-compare" ? (
				<Top18VoteCompareLastRefreshTime />
			) : page === "top18-votes" ? (
				<Top18VoteLastRefreshTime />
			) : page === "top16-vote-trend" || page === "top16-rank-trend" ? (
				<Top16TrendsLastRefreshTime />
			) : page === "top16-vote-compare" ? (
				<Top16VoteCompareLastRefreshTime />
			) : page === "top16-votes" ? (
				<Top16VoteLastRefreshTime />
			) : page === "top14-vote-trend" || page === "top14-rank-trend" ? (
				<Top14TrendsLastRefreshTime />
			) : page === "top14-vote-compare" ? (
				<Top14VoteCompareLastRefreshTime />
			) : page === "top14-votes" ? (
				<Top14VoteLastRefreshTime />
			) : page === "top12-vote-trend" || page === "top12-rank-trend" ? (
				<Top12TrendsLastRefreshTime />
			) : page === "top12-vote-compare" ? (
				<Top12VoteCompareLastRefreshTime />
			) : (
				<Top12VoteLastRefreshTime />
			)}
			<Divider />
			{(!["top14-votes", "top12-votes"].includes(page) || width <= 500) && (
				<List>
					<ListItem dense>
						<Stack direction="row" spacing={1} alignItems="center">
							<Typography>🌸 校花</Typography>
							<Switch
								checked={listOption === "m"}
								onChange={handleChange}
								name="listOption"
							/>
							<Typography>校草 🍀</Typography>
						</Stack>
					</ListItem>
				</List>
			)}
			<Divider />
			<List>
				<ListItem dense>
					<FormControl size="small" fullWidth>
						<InputLabel>選擇資料</InputLabel>
						<Select
							name="page"
							value={page}
							label="選擇資料"
							onChange={handleChange}
						>
							<MenuItem value="overall-rank-trend">綜合排名走勢</MenuItem>
							<ListSubheader>12 強 ➡️ 10 強 (第五週)</ListSubheader>
							<MenuItem value="top12-votes">12 強 票數</MenuItem>
							<MenuItem value="top12-rank-trend">12 強 排名走勢</MenuItem>
							<MenuItem value="top12-vote-trend">12 強 投票走勢</MenuItem>
							<MenuItem value="top12-vote-compare">12 強 投票比較</MenuItem>
							<ListSubheader>14 強 ➡️ 12 強 (第四週)</ListSubheader>
							<MenuItem value="top14-votes">14 強 票數</MenuItem>
							<MenuItem value="top14-rank-trend">14 強 排名走勢</MenuItem>
							<MenuItem value="top14-vote-trend">14 強 投票走勢</MenuItem>
							<MenuItem value="top14-vote-compare">14 強 投票比較</MenuItem>
							<ListSubheader>16 強 ➡️ 14 強 (第三週)</ListSubheader>
							<MenuItem value="top16-votes">16 強 票數</MenuItem>
							<MenuItem value="top16-rank-trend">16 強 排名走勢</MenuItem>
							<MenuItem value="top16-vote-trend">16 強 投票走勢</MenuItem>
							<MenuItem value="top16-vote-compare">16 強 投票比較</MenuItem>
							<ListSubheader>18 強 ➡️ 16 強 (第二週)</ListSubheader>
							<MenuItem value="top18-votes">18 強 票數</MenuItem>
							<MenuItem value="top18-rank-trend">18 強 排名走勢</MenuItem>
							<MenuItem value="top18-vote-trend">18 強 投票走勢</MenuItem>
							<MenuItem value="top18-vote-compare">18 強 投票比較</MenuItem>
							<ListSubheader>21 強 ➡️ 18 強 (第一週)</ListSubheader>
							<MenuItem value="top21-votes">21 強 票數</MenuItem>
							<MenuItem value="top21-rank-trend">21 強 排名走勢</MenuItem>
							<MenuItem value="top21-vote-trend">21 強 投票走勢</MenuItem>
							<MenuItem value="top21-vote-compare">21 強 投票比較</MenuItem>
							<ListSubheader>30 強 ➡️ 21 強</ListSubheader>
							<MenuItem value="top30-votes">30 強 票數</MenuItem>
							<MenuItem value="top30-rank-trend">30 強 排名走勢</MenuItem>
							<MenuItem value="top30-vote-trend">30 強 投票走勢</MenuItem>
							<ListSubheader>51 強 ➡️ 30 強</ListSubheader>
							<MenuItem value="top51-votes">51 強 票數</MenuItem>
							<MenuItem value="top51-trend">51 強 排名走勢</MenuItem>
						</Select>
					</FormControl>
				</ListItem>
			</List>
			<Divider />
			{page.includes("-votes") && (
				<>
					<List>
						<ListItem dense>
							<ListItemText>排序</ListItemText>
							<Stack direction="row" spacing={1} alignItems="center">
								<Typography>號碼</Typography>
								<Switch
									checked={sortEnabled}
									onChange={handleChange}
									name="sortEnabled"
								/>
								<Typography>票數</Typography>
							</Stack>
						</ListItem>
					</List>
					{page.includes("top14-votes") && sortEnabled && width >= 800 && (
						<Top14VoteOptions />
					)}
					<Divider />
				</>
			)}
			{page.includes("top30-vote-trend") && (
				<>
					<Top30VoteTrendOptions />
					<Divider />
				</>
			)}
			{(page.includes("top21-rank-trend") ||
				page.includes("top21-vote-trend")) && (
				<>
					<Top21TrendOptions />
					<Divider />
				</>
			)}
			{(page.includes("top18-rank-trend") ||
				page.includes("top18-vote-trend")) && (
				<>
					<Top18TrendOptions />
					<Divider />
				</>
			)}
			{(page.includes("top16-rank-trend") ||
				page.includes("top16-vote-trend")) && (
				<>
					<Top16TrendOptions />
					<Divider />
				</>
			)}
			{(page.includes("top14-rank-trend") ||
				page.includes("top14-vote-trend")) && (
				<>
					<Top14TrendOptions />
					<Divider />
				</>
			)}
			{page.includes("top12-rank-trend") && (
				<>
					<Top12RankTrendOptions />
					<Divider />
				</>
			)}
			{page.includes("top12-vote-trend") && (
				<>
					<Top12VoteTrendOptions />
					<Divider />
				</>
			)}
			{page.includes("overall-rank-trend") && (
				<>
					<OverallRankTrendOptions />
					<Divider />
				</>
			)}
			<List subheader={<ListSubheader component="div">官方連結</ListSubheader>}>
				<MenuItem
					onClick={() => {
						window.open("https://thenextera2022.com/", "_blank");
					}}
				>
					<ListItemIcon>
						<Icon size={1} path={mdiWeb} />
					</ListItemIcon>
					<ListItemText>官方網站</ListItemText>
				</MenuItem>
				<MenuItem
					onClick={() => {
						window.open("https://vote.thenextera2022.com/", "_blank");
					}}
				>
					<ListItemIcon>
						<Icon size={1} path={mdiVote} />
					</ListItemIcon>
					<ListItemText>立即投票</ListItemText>
				</MenuItem>
				<MenuItem
					onClick={() => {
						window.open("https://www.instagram.com/thenextera2022/", "_blank");
					}}
				>
					<ListItemIcon>
						<Icon size={1} path={mdiInstagram} />
					</ListItemIcon>
					<ListItemText>@thenextera2022</ListItemText>
				</MenuItem>
				<MenuItem
					onClick={() => {
						window.open(
							"https://www.instagram.com/ntr.nexttrialrun/",
							"_blank"
						);
					}}
				>
					<ListItemIcon>
						<Icon size={1} path={mdiInstagram} />
					</ListItemIcon>
					<ListItemText>@ntr.nexttrialrun</ListItemText>
				</MenuItem>
				<MenuItem
					onClick={() => {
						window.open(
							"https://www.instagram.com/trialanderror924/",
							"_blank"
						);
					}}
				>
					<ListItemIcon>
						<Icon size={1} path={mdiInstagram} />
					</ListItemIcon>
					<ListItemText>@trialanderror924</ListItemText>
				</MenuItem>
			</List>
			<Divider />
			<List>
				<ListItem dense>
					<ListItemText>
						<Typography variant="caption" display="block" gutterBottom>
							聲明: 本網站並非官方製作, 投票資料只供參考之用, 一切請依官方為準。
							所有校花校草的相片及資料、活動商標的版權全部屬於試當真所有。
						</Typography>
					</ListItemText>
				</ListItem>
			</List>
			<Divider />
			<List>
				<ListItem dense>
					{darkModeEnabled ? (
						<IconButton
							onClick={() => {
								setDarkModeEnabled(false);
							}}
						>
							<Icon size={1} path={mdiWeatherNight} />
						</IconButton>
					) : (
						<IconButton
							onClick={() => {
								setDarkModeEnabled(true);
							}}
						>
							<Icon size={1} path={mdiWhiteBalanceSunny} />
						</IconButton>
					)}
					{page === "top30-vote-trend" && <Top30DataExportButton />}
					{(page === "top21-rank-trend" || page === "top21-vote-trend") && (
						<Top21DataExportButton />
					)}
					{(page === "top18-rank-trend" || page === "top18-vote-trend") && (
						<Top18DataExportButton />
					)}
					{(page === "top16-rank-trend" || page === "top16-vote-trend") && (
						<Top16DataExportButton />
					)}
					{(page === "top14-rank-trend" || page === "top14-vote-trend") && (
						<Top14DataExportButton />
					)}
					{(page === "top12-rank-trend" || page === "top12-vote-trend") && (
						<Top12DataExportButton />
					)}
				</ListItem>
			</List>
		</>
	);
};

export default Menu;
